import { render } from "./TableWithFixedHeader.vue?vue&type=template&id=09fab50e"
import script from "./TableWithFixedHeader.vue?vue&type=script&lang=js"
export * from "./TableWithFixedHeader.vue?vue&type=script&lang=js"
script.render = render

export default script